/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

( function( $ ) {
	
	$( document ).ready( function() {
		if( $( '.producers-near-me' ).length ) {
			var latlng = new google.maps.LatLng( GeoLocation.lat, GeoLocation.lng );
			var geocoder = new google.maps.Geocoder();
			var container = $( '.producers-near-me .news-grid .container' );
			
			container.html( '<p class="loading"><img src="/wp-content/themes/smakriket/dist/images/ajax-loader.gif" alt="Loading..."></p>' );

			geocoder.geocode( {location:latlng}, function( results ) {
				$.post( {
					url : producer.ajaxurl,
					data : { 'action': 'producersNearMe', 'lat': GeoLocation.lat, 'lng': GeoLocation.lng },
					success: function( response ) {
						container.html( response );
						
						Pagination.init();
					}
				} );
			} );
		}
	} );
	
} ) ( jQuery );